export const GET_DEPSTRADDRESS = 'GET_DEPSTRADDRESS';
export const SET_PRIOR_ADDRESS = 'SET_PRIOR_ADDRESS';
export const SET_POST_ADDRESS = 'SET_POST_ADDRESS';

export function getDepStreet(dependentStreetAddress) {
    return {
        type: GET_DEPSTRADDRESS,
        data: dependentStreetAddress
    }
}

export function setPriorEnlistmentAddress(priorAddress) {
    return {
        type: SET_PRIOR_ADDRESS,
        data: priorAddress
    }
}

export function setPostEnlistmentAddress(postAddress) {
    return {
        type: SET_POST_ADDRESS,
        data: postAddress
    }
}
